import React from 'react'
import AddAppointments from '../../components/appointments/AddAppointments'
import MainLayout from '../../layout/MainLayout'

const AddAppointmentsPage = () => {
  return (
    <MainLayout>
        <AddAppointments />
    </MainLayout>
  )
}

export default AddAppointmentsPage